import Cookie from '/app/utils/cookie';

const urlIn = config => path => config.url.startsWith(path);

export const applyIdentity = axios => {
    axios.interceptors.request.use(config => {
        config.params = config.params || {};

        config.params['fingerprint'] = Cookie.get('fingerprint');

        if (config.method === 'post') {
            const scouted = ['/ideas', '/challenges', '/content/topics', '/content/contexts'];
            const scoutId = Cookie.get('scout_id');

            if (scouted.some(urlIn(config)) && scoutId && scoutId !== 'null') {
                config.params['scout_id'] = scoutId;
            }
        }

        return config;
    });
};
